module.exports = __webpack_public_path__ + "static/media/upgrade.a3707157.png";